import { render } from "./nws_alerts.vue?vue&type=template&id=6b0770e7"
import script from "./nws_alerts.vue?vue&type=script&lang=js"
export * from "./nws_alerts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__